import {FC, useEffect} from "react";
import {SiteContext, useNewSiteContext} from "../../../../store/siteContext.ts";
import FullPageLoader from "../../../../templates/FullPageLoader.tsx";
import {Route, Routes, useParams} from "react-router";
import {getSite} from "../../../../api/site.ts";
import LinkPage from "./LinkPage.tsx";
import OpenIssuesPage from "./OpenIssuesPage.tsx";
import IssueDetailsPage from "./IssueDetailsPage.tsx";

const SiteIndex: FC = () => {
    const siteContext = useNewSiteContext();
    const { siteId } = useParams();

    useEffect(() => {
        if (!siteId) {
            return
        }

        getSite(siteId).then(siteContext.setSite)
    }, []);

    if (!siteContext.site) {
        return <FullPageLoader />
    }

    return <SiteContext.Provider value={siteContext}>
        <Routes>
            <Route path="/" element={<OpenIssuesPage />} />
            <Route path="/issue/:issueId/details" element={<IssueDetailsPage />} />
            <Route path="/issues" element={<OpenIssuesPage />} />
            <Route path="/welcome" element={<LinkPage />} />
            { /* <Route path="/generate-report" element={<GenerateReportPage />} /> */}
            <Route path="*" element={<LinkPage />} />
        </Routes>
    </SiteContext.Provider>
}

export default SiteIndex
